import React, {useState,useEffect}  from 'react';
import './Shop.css';
import Product from '../Product/Product';
import Cart from '../Cart/Cart';


const Shop = () => {

    const [products,setProducts] =useState([]);

    // const [cart, setCart] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);

    useEffect( ()=>{
        fetch('products.json')
        .then(res=>res.json())
        // .then(data=>setItems(data))
        .then(data=>setProducts(data.slice(0,30)))
    },[]);

    /* const handleAddToCart = (product)=>{
         console.log(product);
         // do not do this: cart.push(product);
        const newCart = [...cart, product];
        setCart(newCart);
    }  */


    const selectButton = (id)=>{
        // console.log(id);
        if (selectedProducts.length >= 4) {
            alert("Can't add more than 4 Products.");
        }
        else {
            const exists = selectedProducts.find(selectedProduct => selectedProduct.id === id);
            if (exists) {
                alert("Can't add duplicate Products.");
            }
            else {
                const newSelectedProducts = [...selectedProducts, products.find(product => product.id === id)]
                setSelectedProducts(newSelectedProducts);
            }
        }
    }

    
    const removeItem = (id) => {
        const newSelectedProducts = selectedProducts.filter(selectedProduct => selectedProduct.id !== id);
        setSelectedProducts(newSelectedProducts);
    }

    const clearList = () => {
        setSelectedProducts([]);
    }


    return (
        <div className="shop-container mt-5">
            <div>
                <h3 className="text-2xl text-white mb-10 text-center">Product List: {products.length}</h3>

                <div className="products">
                {
                    products.map(product=><Product
                    key={product.id}
                    product={product}
                    selectButton={selectButton}
                    ></Product>)
                }
                </div>

            </div>
            <div className="cart-container">
                <Cart
                 key={selectedProducts.length}
                    selectedProducts={selectedProducts} 
                    removeItem={removeItem} 
                    clearList={clearList}
               ></Cart> 
            </div>
        </div>
    );
};

export default Shop;